/* BestRest :: productkaart, wissel van dikte

   De DIKTE-pil zit binnen de kaartlink, dus een klik sprong naar de
   productpagina. Nu blijf je op het overzicht en wissel je met die pil
   tussen de beschikbare diktes.

   De diktes staan in data-br-thick op de kaart. Staat er ook een
   data-br-firm-thick, dan verandert de stevigheid mee: bij de 300
   Cooltouch is 21 cm medium en 25 cm stevig. Zonder die mapping wisselt
   alleen de dikte en blijft de rest staan.

   Werkt op elke pagina waar de kaart voorkomt, want de afhandeling hangt
   aan het document en niet aan een sectie. */
(function () {
  'use strict';

  function leesDiktes(kaart) {
    var ruw = kaart.getAttribute('data-br-thick') || '';
    return ruw.split(',').map(function (t) { return t.trim(); }).filter(Boolean);
  }

  function leesStevigheidPerDikte(kaart) {
    var ruw = kaart.getAttribute('data-br-firm-thick') || '';
    var map = {};
    ruw.split('|').forEach(function (paar) {
      var d = paar.split(':');
      if (d.length === 2) map[d[0].trim()] = d[1].trim();
    });
    return map;
  }

  /* "21:EUR 159,00|25:EUR 199,00" -> { "21": "EUR 159,00", ... }
     De bedragen zijn in Liquid al door de money-filter gehaald, zodat de
     notatie gelijk is aan wat de server rendert. Alleen op de eerste
     dubbele punt splitsen, want het bedrag kan er zelf geen bevatten. */
  function leesPrijsPerDikte(kaart) {
    var ruw = kaart.getAttribute('data-br-price-thick') || '';
    var map = {};
    ruw.split('|').forEach(function (paar) {
      var i = paar.indexOf(':');
      if (i > 0) map[paar.slice(0, i).trim()] = paar.slice(i + 1).trim();
    });
    return map;
  }

  /* De collectiepagina schrijft hele bedragen als "EUR 159,-", terwijl de
     money-filter "EUR 159,00" geeft. Welke van de twee er staat hangt af van
     de pagina, dus we nemen de schrijfwijze over die er al stond. */
  function volgNotatie(huidig, nieuw) {
    if (/,-\s*$/.test(huidig || '')) return nieuw.replace(/,00\s*$/, ',-');
    return nieuw;
  }

  /* "21 cm" -> "21", zodat de tekst in de pil met data-br-thick matcht */
  function alleenGetal(tekst) {
    var m = String(tekst).match(/\d+/);
    return m ? m[0] : '';
  }

  function wissel(pil, kaart) {
    var diktes = leesDiktes(kaart);
    if (diktes.length < 2) return;

    /* De pil toont alle diktes naast elkaar; wisselen is de nadruk
       verplaatsen, niet de tekst vervangen. */
    var opties = pil.querySelectorAll('.br-col__thick-opt');
    if (!opties.length) return;

    var huidigeIndex = 0;
    for (var n = 0; n < opties.length; n++) {
      if (opties[n].classList.contains('is-actief')) huidigeIndex = n;
    }
    var volgendeIndex = (huidigeIndex + 1) % opties.length;
    opties[huidigeIndex].classList.remove('is-actief');
    opties[volgendeIndex].classList.add('is-actief');

    var volgende = opties[volgendeIndex].getAttribute('data-br-thick-opt')
      || alleenGetal(opties[volgendeIndex].textContent);
    if (!volgende) return;

    /* De stevigheid verandert alleen mee als we hem voor deze dikte kennen. */
    var perDikte = leesStevigheidPerDikte(kaart);
    var woord = perDikte[volgende];
    if (woord) {
      var cel = kaart.querySelector('.br-col__profile-cell .br-col__profile-word');
      if (cel) cel.textContent = woord;
    }

    /* De vanaf-prijs hoort bij de gekozen dikte. De bedragen komen al
       opgemaakt uit Liquid, dus hier alleen omwisselen. */
    var prijzen = leesPrijsPerDikte(kaart);
    var bedrag = prijzen[volgende];
    if (bedrag) {
      var prijsEl = kaart.querySelector('.br-col__price [data-br-price]');
      if (prijsEl) prijsEl.textContent = volgNotatie(prijsEl.textContent, bedrag);
    }

    pil.setAttribute('aria-label', 'Dikte ' + volgende + ' cm, klik om te wisselen');
  }

  document.addEventListener('click', function (e) {
    var pil = e.target.closest ? e.target.closest('.br-col__thick') : null;
    if (!pil) return;

    var kaart = pil.closest('[data-br-thick]');
    if (!kaart || leesDiktes(kaart).length < 2) return;

    /* De kaart is zelf een link. Zonder dit sprong je naar de productpagina. */
    e.preventDefault();
    e.stopPropagation();
    wissel(pil, kaart);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var pil = e.target.closest ? e.target.closest('.br-col__thick') : null;
    if (!pil) return;
    var kaart = pil.closest('[data-br-thick]');
    if (!kaart || leesDiktes(kaart).length < 2) return;
    e.preventDefault();
    e.stopPropagation();
    wissel(pil, kaart);
  });

  /* Pillen met meer dan een dikte bedienbaar maken. Geen opmaak aanraken:
     alleen de rollen zetten die een schermlezer en het toetsenbord nodig
     hebben. */
  function markeer(root) {
    (root || document).querySelectorAll('[data-br-thick] .br-col__thick').forEach(function (pil) {
      var kaart = pil.closest('[data-br-thick]');
      if (!kaart || leesDiktes(kaart).length < 2) return;
      if (pil.getAttribute('data-br-thick-toggle')) return;
      pil.setAttribute('data-br-thick-toggle', '1');
      pil.setAttribute('role', 'button');
      pil.setAttribute('tabindex', '0');
      pil.style.cursor = 'pointer';
      var actief = pil.querySelector('.br-col__thick-opt.is-actief');
      pil.setAttribute('aria-label', 'Dikte ' + (actief ? actief.textContent.trim() : '')
        + ' cm van ' + leesDiktes(kaart).join(' of ') + ' cm, klik om te wisselen');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { markeer(); });
  } else {
    markeer();
  }

  /* Filters en sorteren bouwen kaarten opnieuw op. */
  var mo = new MutationObserver(function () { markeer(); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
